import MuiFormControlLabel from '@mui/material/FormControlLabel'
import styled from '@emotion/styled'

export const FormControlLabel = styled(MuiFormControlLabel)`
  font-size: 16px;
  font-weight: 400;
  letter-spacing: normal;
  line-height: 20px;

  &.Mui-disabled {
    color: rgba(0, 0, 0, 0.38);
  }
`
